export default __webpack_public_path__ + "navigation-examples-building-extrusion-v1-960-50aca39e493db4917ff54bb871da5f35.png";